<template>
    <el-select
        v-model="selected"
        filterable
        :placeholder="placeholder"
        name="country"
        placeholder="Country (Select one)"
        @change="handleChange">
        <el-option
            v-for="country in options"
            :key="country.id"
            :label="country.name"
            :value="country.name">
        </el-option>
    </el-select>
</template>

<script>
    import countries from './countries.json'

    export default {
        props: {
            initial: {
                type: String,
                default: 'United Kingdom'
            },

            placeholder: {
                type: String,
                default: 'Click to select a country'
            }
        },

        data() {
            return {
                selected: this.initial,
                options: countries
            }
        },

        methods: {
            handleChange(country) {
                this.$emit('change', country);
            }
        },

        watch: {
            initial(country) {
                this.selected = country;
            }
        },
    }
</script>
